module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"expandEvidence":"Evidence","targetGroup":"Target group"},"de":{"expandEvidence":"Nachweise","targetGroup":"Zielgruppe"}}')
  delete Component.options._Ctor
}
